import React from "react";
import ReactDOM from "react-dom/client";
import "./main/index.scss";
import { Store } from "./helpers/store";
import { Provider } from "react-redux";
import Router from "./main/router";
import TagManager from "react-gtm-module"; // Importe a biblioteca

const tagManagerArgs = {
  gtmId: "GTM-MLPD6KNQ",
};


// Inicialize o GTM
TagManager.initialize(tagManagerArgs);


// Aqui carrega na aplicação toda, inclusive na página de login
//const script = document.createElement("script");
//script.src = "//code.jivosite.com/widget/VAVpMoc5qj";
//script.async = true;
//document.body.appendChild(script);




const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={Store}>
    <Router />
  </Provider>
);